import { supabase } from '../lib/supabase';

export async function trackPageView(pagePath: string) {
  try {
    await supabase.from('page_views').insert([
      {
        page_path: pagePath,
        user_agent: navigator.userAgent
      }
    ]);
  } catch (error) {
    console.error('Error tracking page view:', error);
  }
}
 